export default "__VITE_ASSET__BWm2gFWb__"